import {FETCH_SAMPLE_SIZE, UPDATE_SAMPLE_SIZE, FETCH_MULTI_SAMPLE_SIZE, FETCH_SAMPLE_SIZE_SUCCESS, FETCH_MULTI_SAMPLE_SIZE_SUCCESS, FETCH_SAMPLE_SIZE_ERROR, FETCH_MULTI_SAMPLE_SIZE_ERROR, RESET_SAMPLE_SIZE} from "constants/ActionTypes";

export const fetchSampleSize = (params) => {
  return {
    type: FETCH_SAMPLE_SIZE,
    params,
  }
};

export const fetchMultiSampleSize = (params) => {
  return {
    type: FETCH_MULTI_SAMPLE_SIZE,
    params,
  }
};

export const fetchSampleSizeSuccess = (payload) => {
  return {
    type: FETCH_SAMPLE_SIZE_SUCCESS,
    payload,
  }
};

export const fetchMultiSampleSizeSuccess = (payload) => {
  return {
    type: FETCH_MULTI_SAMPLE_SIZE_SUCCESS,
    payload,
  }
};

export const fetchSampleSizeError = (error) => {
  return {
    type: FETCH_SAMPLE_SIZE_ERROR,
    payload: error
  }
};

export const fetchMultiSampleSizeError = (error) => {
  return {
    type: FETCH_MULTI_SAMPLE_SIZE_ERROR,
    payload: error
  }
};

export const updateSampleSize = (params) => {
  return {
    type: UPDATE_SAMPLE_SIZE,
    params,
  }
};

export const resetSampleSize = () => {
  return {
    type: RESET_SAMPLE_SIZE,
  }
};

